import {
  AnimatedButtonContainer,
  AnimatedButtonRow,
  Button,
} from "@babackapp/customer-ui/components/button";
import {
  Header,
  HeaderDescription,
  HeaderTitle,
} from "@babackapp/customer-ui/components/header";
import { Label } from "@babackapp/customer-ui/components/label";
import {
  Option,
  OptionAction,
  OptionDescription,
  OptionIcon,
  OptionsList,
  OptionTitle,
} from "@babackapp/customer-ui/components/option";
import { RadioGroup, RadioGroupItem } from "@babackapp/customer-ui/components/radio-group";
import { WidgetPage } from "@babackapp/customer-ui/components/widget-page";
import { EnterIcon } from "@radix-ui/react-icons";
import { BanknoteIcon, TagIcon } from "lucide-react";
import { Controller } from "react-hook-form";
import { useShopNowRemainingCredit } from "../hooks/use-shop-now-remaining-credit";

export function ShopNowRemainingCreditPage() {
  const { form, forcedMethod, hasDiscountEnabled, formattedRemaining, handleConfirm } =
    useShopNowRemainingCredit();

  if (forcedMethod) {
    return (
      <WidgetPage>
        <Header>
          <HeaderTitle>Crédit restant</HeaderTitle>
          <HeaderDescription>
            {forcedMethod === "discount"
              ? `Il vous reste ${formattedRemaining} de crédit qui sera converti en bon de réduction.`
              : `Il vous reste ${formattedRemaining} de crédit qui vous sera remboursé.`}
          </HeaderDescription>
        </Header>
        <AnimatedButtonRow variants={{}}>
          <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
            <Button onClick={handleConfirm}>
              <EnterIcon />
              Continuer
            </Button>
          </AnimatedButtonContainer>
        </AnimatedButtonRow>
      </WidgetPage>
    );
  }

  return (
    <WidgetPage>
      <Header>
        <HeaderTitle>Crédit restant</HeaderTitle>
        <HeaderDescription>
          Il vous reste {formattedRemaining} de crédit. Comment souhaitez-vous l&apos;utiliser ?
        </HeaderDescription>
      </Header>

      <Controller
        control={form.control}
        name="method"
        render={({ field }) => (
          <RadioGroup
            value={field.value}
            onValueChange={field.onChange}
            className="w-full mt-4"
          >
            {hasDiscountEnabled && (
              <Label htmlFor="remaining-discount">
                <OptionsList>
                  <Option>
                    <OptionIcon><TagIcon /></OptionIcon>
                    <OptionTitle>Bon de réduction</OptionTitle>
                    <OptionDescription>
                      Recevez {formattedRemaining} sous forme de bon de réduction à utiliser sur
                      votre prochaine commande.
                    </OptionDescription>
                    <OptionAction>
                      <RadioGroupItem value="discount" id="remaining-discount" />
                    </OptionAction>
                  </Option>
                </OptionsList>
              </Label>
            )}
            <Label htmlFor="remaining-refund">
              <OptionsList>
                <Option>
                  <OptionIcon><BanknoteIcon /></OptionIcon>
                  <OptionTitle>Remboursement</OptionTitle>
                  <OptionDescription>
                    Recevez {formattedRemaining} remboursé sur votre moyen de paiement
                    d&apos;origine.
                  </OptionDescription>
                  <OptionAction>
                    <RadioGroupItem value="refund" id="remaining-refund" />
                  </OptionAction>
                </Option>
              </OptionsList>
            </Label>
          </RadioGroup>
        )}
      />

      <AnimatedButtonRow variants={{}}>
        <AnimatedButtonContainer layoutId="line-item-confirm-button" variants={{}}>
          <Button onClick={handleConfirm}>
            <EnterIcon />
            Confirmer
          </Button>
        </AnimatedButtonContainer>
      </AnimatedButtonRow>
    </WidgetPage>
  );
}
